// extracted by mini-css-extract-plugin
export var scoreBoardContainer = "ScoreBoard-module--scoreBoardContainer--175vi";
export var scoreBoardTitle = "ScoreBoard-module--scoreBoardTitle--2PNTk";
export var scoreBoard = "ScoreBoard-module--scoreBoard--7LZgj";